import Account from './components/account_list';
export default (props) => {
  return <Account {...props} />;
};
